import 'app/app.scss';

import {react2angular} from "react2angular";
import {R2ANewBookingNav} from "app/bookings/new/newBookingNav/container";
import {R2AIconButton} from 'app/common/iconButton/container';
import {R2ARaisedButton} from 'app/common/raisedButton/container';
import {R2ATagIcon} from "app/bookings/tags/TagIcon/container";
import {R2ABookingInfo} from "app/bookings/BookingInfo/container";
import {R2ATableSeater} from "app/bookings/TableSeater/container";
import {R2ATimeSlotMessaging} from "app/bookings/TimeSlotMessaging/container";
import {R2AEditBookingFooter} from 'app/bookings/edit/EditBookingFooter/container';
import {R2AStandbyConfirmationMsg} from "app/bookings/edit/StandbyConfirmationMsg/container";
import {R2AStandbyTableSeater} from "app/bookings/edit/StandbyTableSeater/container";
import {R2AMenuOptions} from "app/bookings/bookingOptionsTab/MenuOptions/container";
import {R2ACustomerDetailsBasicEditor} from "app/bookings/edit/CustomerDetailsBasicEditor/container";
import {R2AServicePicker} from 'app/bookings/edit/ServicePicker/container';
import {R2ATimeSelector} from 'app/bookings/edit/TimeSelector/container';
import {R2ABookingDialogHeader} from 'app/bookings/BookingDialogHeader/container';
import {R2ASeatTimeButton} from 'app/common/SeatTimeButton/container';
import { R2APaymentLinkInfo } from 'app/bookings/PaymentLinkInfo/container';
import { R2ABadData } from 'app/common/BadData/container';
import { R2AMegaBookingBot } from 'app/common/MegaBookingBot/container';
import { R2AToastDialog } from 'app/common/ToastDialog/container';
import { R2AEventBlockout } from 'app/settings/EventBlockout/container';
import {R2AEditBookingNotes} from "app/common/EditBookingNotes/container";
import {R2AFlagPhonePicker} from "app/common/FlagPhonePicker/container";
import {R2APlusMinusButton} from "app/common/PlusMinusButton/Container";

import NewBooking from "app/bookings/new/newBooking.controller";
import EditBooking from "app/bookings/edit/editBooking.controller";
import EditBookingOptions from "app/bookings/bookingOptionsTab/edit/editBookingOptions.controller";
import BookingNotes from "app/bookings/new/bookingNotes.directive";
import PaymentConfig from "app/settings/payments/paymentConfig.directive";
import NewBookingsTags from "app/bookings/new/newBookingTags.directive";
import NewBookingDetails from "app/bookings/new/newBookingDetails.directive";
import BookingsTimeList from "app/bookings/timeList/bookingsTimeList.directive";
import Draggable from "app/bookings/new/draggable";
import EventEditorCtrl from "app/settings/events/eventEditor.controller";
import EventsCtrl from 'app/settings/events/events.controller';
import BookingsTags from "app/bookings/tags/bookingsTags.directive";
import BookingsCtrl from "app/bookings/bookingsController/bookings.controller";
import MarkdownEditor from "app/common/markdownEditor/markdownEditor.directive";
import EditServiceGroupCtrl from "app/settings/serviceGroups/editServiceGroup.controller";
import ServiceGroupsCtrl from "app/settings/serviceGroups/serviceGroups.controller";
import HeaderFilterComponent from "app/bookings/headerFilter/headerFilter.component";
import MenuOptionsCtrl from 'app/settings/menuoptions/menuOptionsController/menuOptions.controller';
import MenuOptionEditCtrl from 'app/settings/menuoptions/editMenuOption/editMenuOption.controller';
import ChildMenuOptions from 'app/settings/menuoptions/childMenuOptions/childMenuOptions.directive';
import ColoredChip from 'app/settings/menuoptions/coloredChip/coloredChip.directive';
import MenuOptionsAutocomplete
  from 'app/settings/menuoptions/menuOptionsAutocomplete/menuOptionsAutocomplete.directive';
import RunSheet from 'app/bookings/runSheet/runSheet.directive';
import ExportRunsheetDialogCtrl from 'app/bookings/runSheet/exportRunsheetDialog.controller';
import ExportExcelReportDialogCtrl from 'app/bookings/runSheet/exportExcelReportDialog.controller';
import BookingSummaryComponent from 'app/bookings/bookingSummary/bookingSummary.component';
import TimeListPopoverComponent from 'app/bookings/timeListPopover/timeListPopover.component';
import ExpandablePanelComponent from 'app/common/expandablePanel/expandablePanel.component';
import SetUpCtrl from 'app/setup/setup.controller';
import BrowserWarningCtrl from 'app/setup/browserWarning.controller';
import StatusEditor from 'app/bookings/statusEditor/statusEditor.directive';
import StatusBookingEditorCtrl from 'app/bookings/statusEditor/statusBookingEditor.controller';
import AdminLoginCtrl from 'app/login/adminLogin.controller';
import LoginCtrl from 'app/login/login.controller';
import CustomerDetails from 'app/customers/customerDetails/customerDetails.directive';
import EmailAutocomplete from 'app/customers/customerDetails/emailAutocomplete/emailAutocomplete.directive';
import AffectedBookingsConfirmCtrl from 'app/settings/confirmDialogs/affectedBookingsConfirm.controller';
import LayoutEditCtrl from 'app/settings/layouts/layoutEdit.controller';
import SectionsCtrl from 'app/settings/sections/sections.controller';
import PeopleEditor from 'app/bookings/peopleEditor/peopleEditor.directive';
import BookingChange from 'app/bookings/bookingChange/bookingChange.directive';
import DragBookingConfirmCtrl from 'app/bookings/timeList/dragBookingConfirm/dragBookingConfirm.controller';
import CancelledNoShowBookingsCtrl from 'app/reports/cancelledNoShowBookings/cancelledNoShowBookings.controller'
import StatusCtrl from 'app/settings/status/status.controller';
import BlockOutsCtrl from 'app/settings/blockouts/blockouts.controller';
import BlockoutEditorCtrl from 'app/settings/blockouts/blockoutEditor.controller';
import GlobalSearchCtrl from 'app/common/globalSearch/globalSearch.controller'
import WizardCtrl from 'app/wizard/wizard.controller';
import QuickBlockoutsCtrl from 'app/bookings/blockoutsInline/quickBlockouts.controller';
import SaveBlockoutDailogCtrl from 'app/bookings/blockoutsInline/saveBlockoutDialog.controller';
import BlockoutsListCtrl from 'app/bookings/blockoutsInline/list/blockoutsList.controller';
import EditCustomerCtrl from 'app/customers/edit/editCustomer.controller';
import DurationDrag from 'app/bookings/durationDrag/durationDrag.directive';
import OverviewCtrl from 'app/reports/overview/overview.controller';
import NewLayoutCtrl from 'app/settings/layouts/newLayout.controller';
import Timeline from 'app/common/timeline/timeline.directive';
import EditScheduleCtrl from 'app/settings/schedule/editSchedule.controller';
import Booking from 'app/bookings/booking/booking.directive';
import MainCtrl from 'app/common/main/main.controller';
import BookingArrivalTimesCtrl from 'app/reports/bookingsArrivalTimes/bookingsArrivalTimes.controller';
import DateLessThan from 'app/common/validation/dateLessThan.directive';
import DateGreaterThan from 'app/common/validation/dateGreaterThan.directive';
import YearlyValidDay from 'app/common/validation/yearlyValidDay.directive';
import UniqueTableName from 'app/common/validation/uniqueTableName.directive';
import LengthGreaterThan from 'app/common/validation/lengthGreaterThan.directive';
import PhoneVaild from 'app/common/validation/phoneValid.directive';
import Header from 'app/common/header/header.directive';
import GuestListComponent from "app/bookings/guestList/guestList.component";
import GuestListItemComponent from "app/bookings/guestList/guestListItem/guestListItem.component";
import DatePicker from "app/common/datePicker/datePicker.directive";
import DateTimeButton from "app/common/datePicker/dateTimeButton.directive";
import DateTimePopUp from "app/common/datePicker/dateTimePopUp.directive";
import {TablePlan, SumValidate} from "app/plan/tablePlan.directive";
import AddCustomerDialogCtrl from "app/customers/add/addCustomerDialog.controller";
import NewUpsellCtrl from "app/settings/upsell/newUpsell.controller.js";
import BookingsOverTimeCtrl from "app/reports/bookingsOverTime/bookingsOverTime.controller";
import ExportCustomerCtrl from "app/customers/export/exportCustomer.controller";
import BookingsList from "app/bookings/list/bookingsList.directive";
import PreAuthDialogCtrl from "app/bookings/preAuth/preAuthDialog.controller";
import TypeSelectCtrl from "app/bookings/typeSelect/typeSelect.controller";
import AppReloadDialogCtrl from "app/common/appReload/appReloadDialog.controller";
import AppUpdateDialogCtrl from "app/common/appUpdate/appUpdateDialog.controller";
import DatePickerDialogCtrl from "app/common/datePickerDialog/datePickerDialog.controller";
import DatesSelector from "app/common/datesSelector/datesSelector.directive";
import LinkTextArea from "app/common/linkTextArea/linkTextArea.directive";
import MainMenu from "app/common/mainMenu/mainMenu.directive";
import OfflineMessage from "app/common/messages/offline.directive";
import NotesCtrl from "app/common/notes/notes.controller";
import PinCtrl from "app/common/pin/pin.controller";
import SideMenu from "app/common/sideMenu/sideMenu.directive";
import StatusInfo from "app/common/statusInfo/statusInfo.directive";
import UnauthorisedDialogCtrl from "app/common/unauthorised/unauthorisedDialog.controller";
import DoubleClick from 'app/common/doubleClick.directive';
import FocusMe from 'app/common/focusMe.directive';
import IfOnce from 'app/common/ifOnce.directive';
import Resizable from 'app/common/resizable';
import NewCustomerCtrl from 'app/customers/new/newCustomer.controller';
import CustomersCtrl from 'app/customers/customers.controller';
import SectionsPlanCtrl from 'app/plan/sectionsPlan.controller';
import SectionsPlan from 'app/plan/sectionsPlan.directive';
import TablePlanCtrl from 'app/plan/tablePlan.controller';
import BookingsErrorsCtrl from 'app/reports/bookingsErrors/bookingsErrors.controller';
import BookingSizeCtrl from 'app/reports/bookingSize/bookingsSize.controller';
import ForecastReportCtrl from 'app/reports/forecast/forecast.controller';
import ReportsCtrl from 'app/reports/reports.controller';
import GiftCardsV1Ctrl from 'app/gift-cards-v1/giftCardsV1.controller';
import GCManagementLoaderCtrl from 'app/gift-cards-v1/management-loader/gcManagementLoader.controller';
import SettingsBookingsCtrl from 'app/settings/bookings/bookings.controller';
import FloorPlanCtrl from 'app/settings/floorPlan/floorPlan.controller';
import FloorPlanSettingsCtrl from 'app/settings/floorPlanV2/floorPlanSettings.controller';
import LayoutsCtrl from 'app/settings/layouts/layouts.controller';
import UniqueTableJoin from 'app/settings/layouts/joinCreated.directive';
import SettingsMaintenanceCtrl from 'app/settings/maintenance/maintenance.controller';
import PaymentConfigBooking from 'app/settings/payments/paymentConfigBooking.directive';
import PaymentDetails from 'app/settings/payments/paymentDetails.directive';
import ScheduleCtrl from 'app/settings/schedule/schedule.controller';
import SectionRequired from 'app/settings/schedule/sectionRequired.directive';
import ServicesOverLap from 'app/settings/schedule/servicesOverLap.directive';
import EditSectionGroupCtrl from 'app/settings/sections/editSectionGroup.controller';
import NewSectionCtrl from 'app/settings/sections/newSection.controller';
import SectionGroupsCtrl from 'app/settings/sections/sectionGroups.controller';
import StatusEditorCtrl from 'app/settings/status/statusEditor.controller';
import EditTableCtrl from 'app/settings/table/editTable.controller';
import TagEditorCtrl from 'app/settings/tags/tagEditor.controller';
import TagsCtrl from 'app/settings/tags/tags.controller';
import SettingsCtrl from 'app/settings/settings.controller';
import StaffCtrl from 'app/staff/staff.controller';
import CreateLayouts from 'app/wizard/layout/createLayouts.directive';
import CreateSchedule from 'app/wizard/schedule/createSchedule.directive';
import CreateSections from 'app/wizard/sections/createSections.directive';
import CreateServices from 'app/wizard/services/createServices.directive';
import SettingsBlockoutEventsCtrl from 'app/settings/blockoutEvents/blockoutEvents.controller';
import DialogController from "app/common/confirmDialog/confirmDialog.controller";
import UniqueStatus from "app/settings/status/uniqueStatus.directive"

// services
import BookingsCalulationsService from 'app/services/bookingsCalculations/bookingsCalulations.service';
import ScheduleService from 'app/services/schedule/schedule.service';
import SetupService from 'app/setup/setup.service';
import AppEventService from 'app/services/appEvent.service';
import AuthService from 'app/services/auth.service';

import BookingsOverTimeReportService from 'app/services/bookingsOverTimeReport.service';
import PouchService from 'app/services/pouch.service';
import StructureService from 'app/services/structure.service';
// import SwCacheService from 'app/services/swCache.service';
import TablesService from 'app/services/tables.service';
import HighChartsService from 'app/reports/highCharts.service';

// filters
import PaymentTypeLabelFilter from 'app/common/filters/paymentTypeLabel.filter';
import BookingsTypeFilter from 'app/bookings/bookingsType.filter';
import AlphaSortFilter from 'app/common/filters/alphaSort.filter';
import CapitalizeFilter from 'app/common/filters/capitalize.filter';
import IdsRemoveFilter from 'app/common/filters/idsRemove.filter';
import NumberSuffixFilter from 'app/common/filters/numberSuffix.filter';
import SplitCamelCaseFilter from 'app/common/filters/splitCamelCase.filter';
import TablesListFilter from 'app/common/filters/tablesList.filter';
import TagListFilter from 'app/common/filters/tagList.filter';
import WeekOrderFilter from 'app/common/filters/weekOrder.filter';
import { localizeDateFilter } from 'app/common/filters/localizeDate.filter';
import { localizeCurrencyFilter } from 'app/common/filters/localizeCurrency.filter';
import { LocaleService } from 'internal-services/locale/locale.service';

import { floorplanConstantMap, floorplanServiceMap } from "app/floorplan.module";
import { legacyConstantMap } from "app/legacy.constants";
import EditBookingActions from "app/actions/editBooking.actions";
import ToastActions from "app/actions/toast.actions";
import { appValues } from "appRoot/app.constants";
import { routeList } from "app/diary.routes";
import { R2ASectionsMaxOccupancy } from "app/common/SectionsMaxOccupancy/container";
import { R2ABookingLinks } from "app/common/BookingLinks/container";
import { R2ABookingOverview } from "app/bookings/edit/BookingOverview/container";
import { R2AStatusSymbol } from "app/common/StatusSymbol/container";
import { R2AMaxOccupancyMessage } from "app/common/MaxOccupancyMessage/container";
import { R2AAlertDialog } from "./common/AlertDialog/container";
import { R2ARepeatBooking } from './bookings/new/RepeatBooking/container';
import { R2AEditRecurringBooking } from './bookings/edit/EditRecurringBooking/container';
import { R2ASimpleDialog } from "./common/SimpleDialog/container";
import { R2ANewSimpleDialog } from "./common/NewSimpleDialog/container";
import { R2ASimpleDialogMain } from "app/common/SimpleDialogMain/container";

import { R2AUpsellMenuOptions } from "app/common/UpsellMenuOptions/container";
import { R2AChipAvatar } from "app/common/ChipAvatar/container";
import { R2ATimelineV2 } from "app/timeline-v2/TimelineV2Loader";
import { R2AFloorPlanV2 } from "app/floorplan-v2/FloorPlanV2Loader";
// import {R2ABookingCreator} from "app/booking-creator/BookingCreatorLoader";
// import {R2ABookingCardList} from "app/booking-card-list/BookingCardListLoader";
import R2AExistingCustomerSearch from "app/customers/ExistingCustomerSearch/container";
import R2AExistingCustomerDisplay from "app/customers/ExistingCustomerDisplay/container";
import R2ABookedBy from "app/customers/BookedByForm/container";
import { R2AResizeBackgroundPanel } from "app/common/resizeBackgroundPanel/container";
import { R2AFloorplanHeader } from "app/common/FloorplanHeader/container";
import { R2AHeaderMenuRight } from "app/common/HeaderMenuRight/container";
import { R2ARangeSlider } from 'app/common/RangeSlider/container';

import RestrictTo from "app/common/restrictTo.directive";

import {
  checkAppVersionAgainstCache,
  cacheRegister,
  tracking,
  stateConfig,
  initServices,
  themeConfig,
  addErrorReporting,
  angularJSConfig,
  authHttpResponseInterceptor,
  apiInterceptor,
  httpProvider, timeoutHttpIntercept, oauth2Interceptor, initOAuth2
} from './diary.module.helpers';
import { R2ABookingButtons } from 'app/common/BookingButtons/container';

const NS = 'DiaryModule';


/**
 * When the floorplan is rewritten (hopefully in 2022) then the floorplan-bundle.js can also be removed, which contains
 * all the remaining uses of underscore.js. The rest of Diary has all been updated to use LoDash and that means
 * the '_.noConflict' handler below can also be removed.
 */
if (window._ && window._().constructor.toString().includes('LodashWrapper')) {
  window.underscore = window._.noConflict();
  console.warn(NS, `
  Lodash library has been detected on the global "window._" object.
  This can break legacy code relying on the Underscore library and so a "noConflict" has been run.
  However, we should be using "lodash-es" anyway, which allows "tree shaking" and does not polute the
  global "_" namespace. Developer should replace their import with "lodash-es".
  `);
}

/**
 * Creates floorplan as a separate module, since it is mostly self contained (except for a few shared services)
 */
const floorplanModule = window.angular.module('floorplan', []); // 'bookIt'
floorplanServiceMap.forEach(({name, value}) => {
  floorplanModule.service(name, value);
});
floorplanConstantMap.forEach(({name, value}) => {
  floorplanModule.constant(name, value);
});


const diaryModule = window.angular
  .module('diary', [
    'floorplan', 'ngMaterial', 'ngAnimate', 'ngTouch', 'ngSanitize',
    'ngStorage', 'ngMessages', 'ui.router', 'highcharts-ng', 'scDateTime', 'markdown'
  ])


  .value('unregister', function (listeners: any[]) {
    if (listeners) {
      for (const listener of listeners) {
        listener();
      }
    }
  })
  .value('isTouchDevice', 'ontouchstart' in document.documentElement)
  .value('scDateTimeI18n', {
    previousMonth: "Previous Month",
    nextMonth: "Next Month",
    incrementHours: "Increment Hours",
    decrementHours: "Decrement Hours",
    incrementMinutes: "Increment Minutes",
    decrementMinutes: "Decrement Minutes",
    switchAmPm: "Switch AM/PM",
    now: "Today",
    cancel: "Cancel",
    save: "Go",
    weekdays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    switchTo: 'Switch to',
    clock: 'Clock',
    calendar: 'Calendar'
  })

  // routes
  .config(($stateProvider: any, $urlRouterProvider: any) => {
    "ngInject";
    routeList.forEach(({name, config}) => $stateProvider.state(name, config));

    // Keep this syntax, otherwise the 'OTHERWISE' state is kept in the $state.go chain and crate an infinite loop
    $urlRouterProvider.otherwise(($injector: any) => {
      const $state = $injector.get('$state');
      $state.transitionTo('bookings');
    });
  })
  .config(function ($sceProvider: any) {
    $sceProvider.enabled(false);
  })

  .config(angularJSConfig)
  .factory('authHttpResponseInterceptor', authHttpResponseInterceptor)
  .factory('apiInterceptor', apiInterceptor)
  .factory('oauth2Interceptor', oauth2Interceptor)
  .factory('timeoutHttpIntercept', timeoutHttpIntercept)
  .config(httpProvider)

  .config(addErrorReporting)
  .config(themeConfig)

  // react components
  .component('newBookingNav', react2angular(...R2ANewBookingNav))
  .component('iconButton', react2angular(...R2AIconButton))
  .component('raisedButton', react2angular(...R2ARaisedButton))
  .component('tagIcon', react2angular(...R2ATagIcon))
  .component('bookingInfo', react2angular(...R2ABookingInfo))
  .component('timeSlotMessaging', react2angular(...R2ATimeSlotMessaging))
  .component('tableSeater', react2angular(...R2ATableSeater))
  .component('editBookingFooter', react2angular(...R2AEditBookingFooter))
  .component('standbyConfirmationMsg', react2angular(...R2AStandbyConfirmationMsg))
  .component('standbyTableSeater', react2angular(...R2AStandbyTableSeater))
  .component('menuOptions', react2angular(...R2AMenuOptions))
  .component('upsellMenuOptions', react2angular(...R2AUpsellMenuOptions))
  .component('customerDetailsBasicEditor', react2angular(...R2ACustomerDetailsBasicEditor))
  .component('servicePicker', react2angular(...R2AServicePicker))
  .component('timeSelector', react2angular(...R2ATimeSelector))
  .component('bookingDialogHeader', react2angular(...R2ABookingDialogHeader))
  .component('seatTimeButton', react2angular(...R2ASeatTimeButton))
  .component('sectionsMaxOccupancy', react2angular(...R2ASectionsMaxOccupancy))
  .component('bookingLinks', react2angular(...R2ABookingLinks))
  .component('bookingOverview', react2angular(...R2ABookingOverview))
  .component('statusSymbol', react2angular(...R2AStatusSymbol))
  .component('paymentLinkInfo', react2angular(...R2APaymentLinkInfo))
  .component('maxOccupancyMessage', react2angular(...R2AMaxOccupancyMessage))
  .component('alertDialog', react2angular(...R2AAlertDialog))
  .component('chipAvatar', react2angular(...R2AChipAvatar))
  .component('badData', react2angular(...R2ABadData))
  .component('megaBookingBot', react2angular(...R2AMegaBookingBot))
  .component('toastDialog', react2angular(...R2AToastDialog))
  .component('editBookingNotes', react2angular(...R2AEditBookingNotes))
  .component('flagPhonePicker', react2angular(...R2AFlagPhonePicker))
  .component('repeatBookings', react2angular(...R2ARepeatBooking))
  .component('editRecurringBooking', react2angular(...R2AEditRecurringBooking))
  .component('simpleDialog', react2angular(...R2ASimpleDialog))
  .component('newSimpleDialog', react2angular(...R2ANewSimpleDialog))
  .component('simpleDialogMain', react2angular(...R2ASimpleDialogMain))
  .component('eventBlockout', react2angular(...R2AEventBlockout))
  .component('timelineV2', react2angular(...R2ATimelineV2))
  .component('floorplanV2', react2angular(...R2AFloorPlanV2))
  // .component('bookingCreator', react2angular(...R2ABookingCreator))
  // .component('bookingCardList', react2angular(...R2ABookingCardList))
  .component('existingCustomerSearch', react2angular(...R2AExistingCustomerSearch))
  .component('existingCustomerDisplay', react2angular(...R2AExistingCustomerDisplay))
  .component('bookedByForm', react2angular(...R2ABookedBy))
  .component('resizeBackgroundPanel', react2angular(...R2AResizeBackgroundPanel))
  .component('floorplanHeaderContainer', react2angular(...R2AFloorplanHeader))
  .component('headerMenuRightContainer', react2angular(...R2AHeaderMenuRight))
  .component('rangeSlider', react2angular(...R2ARangeSlider))
  .component('bookingButtons', react2angular(...R2ABookingButtons))
  .component('plusMinusButton', react2angular(...R2APlusMinusButton))

  // angular directives
  .directive('draggable', Draggable)
  .directive('bookingNotes', BookingNotes)
  .directive('paymentConfig', PaymentConfig)
  .directive('newBookingsTags', NewBookingsTags)
  .directive('newBookingDetails', NewBookingDetails)
  .directive('bookingsTags', BookingsTags)
  .directive('markdownEditor', MarkdownEditor)
  .directive('childMenuOptions', ChildMenuOptions)
  .directive('coloredChip', ColoredChip)
  .directive('menuOptionsAutocomplete', MenuOptionsAutocomplete)
  .directive('runSheet', RunSheet)
  .directive('statusEditor', StatusEditor)
  .directive('customerDetails', CustomerDetails)
  .directive('emailAutocomplete', EmailAutocomplete)
  .directive('bookingsTimeList', BookingsTimeList)
  .directive('peopleEditor', PeopleEditor)
  .directive('bookingChange', BookingChange)
  .directive('durationDrag', DurationDrag)
  .directive('timeline', Timeline)
  .directive('booking', Booking)
  .directive('dateLessThan', DateLessThan)
  .directive('dateGreaterThan', DateGreaterThan)
  .directive('yearlyValidDay', YearlyValidDay)
  .directive('uniqueTableName', UniqueTableName)
  .directive('lengthGreaterThan', LengthGreaterThan)
  .directive('phoneVaild', PhoneVaild)
  .directive('header', Header)
  .directive('datePicker', DatePicker)
  .directive('dateTimeButton', DateTimeButton)
  .directive('dateTimePopUp', DateTimePopUp)
  .directive('tablePlan', TablePlan)
  .directive('sumValidate', SumValidate)
  .directive('bookingsList', BookingsList)
  .directive('datesSelector', DatesSelector)
  .directive('linkTextArea', LinkTextArea)
  .directive('mainMenu', MainMenu)
  .directive('offlineMessage', OfflineMessage)
  .directive('sideMenu', SideMenu)
  .directive('statusInfo', StatusInfo)
  .directive('doubleClick', DoubleClick)
  .directive('focusMe', FocusMe)
  .directive('ifOnce', IfOnce)
  .directive('resizable', Resizable)
  .directive('sectionsPlan', SectionsPlan)
  .directive('uniqueTableJoin', UniqueTableJoin)
  .directive('paymentConfigBooking', PaymentConfigBooking)
  .directive('paymentDetails', PaymentDetails)
  .directive('sectionRequired', SectionRequired)
  .directive('servicesOverLap', ServicesOverLap)
  .directive('createLayouts', CreateLayouts)
  .directive('createSchedule', CreateSchedule)
  .directive('createSections', CreateSections)
  .directive('createServices', CreateServices)
  .directive('restrictTo', RestrictTo)
  .directive('uniqueStatus', UniqueStatus)

  // angular components
  .component('headerFilterComponent', HeaderFilterComponent)
  .component('bookingSummaryComponent', BookingSummaryComponent)
  .component('timeListPopoverComponent', TimeListPopoverComponent)
  .component('expandablePanelComponent', ExpandablePanelComponent)
  .component('guestListComponent', GuestListComponent)
  .component('guestListItemComponent', GuestListItemComponent)

  // angular controllers (for routes)
  .controller('MainCtrl', MainCtrl)
  .controller('GlobalSearchCtrl', GlobalSearchCtrl)
  .controller('SetUpCtrl', SetUpCtrl)
  .controller('BrowserWarningCtrl', BrowserWarningCtrl)
  .controller('NewBooking', NewBooking)
  .controller('EditBooking', EditBooking)
  .controller('EditBookingOptions', EditBookingOptions)
  .controller('EventEditorCtrl', EventEditorCtrl)
  .controller('EventsCtrl', EventsCtrl)
  .controller('BookingsCtrl', BookingsCtrl)
  .controller('EditServiceGroupCtrl', EditServiceGroupCtrl)
  .controller('ServiceGroupsCtrl', ServiceGroupsCtrl)
  .controller('OptionsCtrl', MenuOptionsCtrl)
  .controller('MenuOptionEditCtrl', MenuOptionEditCtrl)
  .controller('ExportRunsheetDialogCtrl', ExportRunsheetDialogCtrl)
  .controller('ExportExcelReportDialogCtrl', ExportExcelReportDialogCtrl)
  .controller('StatusBookingEditorCtrl', StatusBookingEditorCtrl)
  .controller('AdminLoginCtrl', AdminLoginCtrl)
  .controller('LoginCtrl', LoginCtrl)
  .controller('SectionsCtrl', SectionsCtrl)
  .controller('AffectedBookingsConfirmCtrl', AffectedBookingsConfirmCtrl)
  .controller('LayoutEditCtrl', LayoutEditCtrl)
  .controller('DragBookingConfirmCtrl', DragBookingConfirmCtrl)
  .controller('CancelledNoShowBookingsCtrl', CancelledNoShowBookingsCtrl)
  .controller('StatusCtrl', StatusCtrl)
  .controller('BlockOutsCtrl', BlockOutsCtrl)
  .controller('BlockoutEditorCtrl', BlockoutEditorCtrl)
  .controller('WizardCtrl', WizardCtrl)
  .controller('QuickBlockoutsCtrl', QuickBlockoutsCtrl)
  .controller('SaveBlockoutDailogCtrl', SaveBlockoutDailogCtrl)
  .controller('BlockoutsListCtrl', BlockoutsListCtrl)
  .controller('EditCustomer', EditCustomerCtrl)
  .controller('OverviewCtrl', OverviewCtrl)
  .controller('NewLayoutCtrl', NewLayoutCtrl)
  .controller('EditScheduleCtrl', EditScheduleCtrl)
  .controller('BookingArrivalTimesCtrl', BookingArrivalTimesCtrl)
  .controller('AddCustomerDialogCtrl', AddCustomerDialogCtrl)
  .controller('NewUpsellCtrl', NewUpsellCtrl)
  .controller('BookingsOverTimeCtrl', BookingsOverTimeCtrl)
  .controller('ExportCustomerCtrl', ExportCustomerCtrl)
  .controller('PreAuthDialogCtrl', PreAuthDialogCtrl)
  .controller('TypeSelectCtrl', TypeSelectCtrl)
  .controller('AppReloadDialogCtrl', AppReloadDialogCtrl)
  .controller('AppUpdateDialogCtrl', AppUpdateDialogCtrl)
  .controller('DatePickerDialogCtrl', DatePickerDialogCtrl)
  .controller('NotesCtrl', NotesCtrl)
  .controller('PinCtrl', PinCtrl)
  .controller('UnauthorisedDialogCtrl', UnauthorisedDialogCtrl)
  .controller('NewCustomerCtrl', NewCustomerCtrl)
  .controller('CustomersCtrl', CustomersCtrl)
  .controller('SectionsPlanCtrl', SectionsPlanCtrl)
  .controller('TablePlanCtrl', TablePlanCtrl)
  .controller('BookingsErrorsCtrl', BookingsErrorsCtrl)
  .controller('BookingSizeCtrl', BookingSizeCtrl)
  .controller('ForecastReportCtrl', ForecastReportCtrl)
  .controller('ReportsCtrl', ReportsCtrl)
  .controller('GiftCardsV1Ctrl', GiftCardsV1Ctrl)
  .controller('GCManagementLoaderCtrl', GCManagementLoaderCtrl)
  .controller('SettingsBookingsCtrl', SettingsBookingsCtrl)
  .controller('FloorPlanCtrl', FloorPlanCtrl)
  .controller('FloorPlanSettingsCtrl', FloorPlanSettingsCtrl)
  .controller('LayoutsCtrl', LayoutsCtrl)
  .controller('SettingsMaintenanceCtrl', SettingsMaintenanceCtrl)
  .controller('ScheduleCtrl', ScheduleCtrl)
  .controller('EditSectionGroupCtrl', EditSectionGroupCtrl)
  .controller('NewSectionCtrl', NewSectionCtrl)
  .controller('SectionGroupsCtrl', SectionGroupsCtrl)
  .controller('StatusEditorCtrl', StatusEditorCtrl)
  .controller('EditTableCtrl', EditTableCtrl)
  .controller('TagEditorCtrl', TagEditorCtrl)
  .controller('TagsCtrl', TagsCtrl)
  .controller('SettingsCtrl', SettingsCtrl)
  .controller('StaffCtrl', StaffCtrl)
  .controller('SettingsBlockoutEventsCtrl', SettingsBlockoutEventsCtrl)
  .controller('DialogController', DialogController)
  //
  // // services
  .service('setupService', SetupService)
  .service('bookingsCalulationsService', BookingsCalulationsService)
  .service('scheduleService', ScheduleService)
  .service('AppEventService', AppEventService)
  .service('AuthService', AuthService)

  .service('bookingsOverTimeReportService', BookingsOverTimeReportService)
  // .service('browserInfoService', BrowserInfoService)
    // .service('eventsService', EventsService)
  .service('pouchService', PouchService)
  .service('structureService', StructureService)
  // .service('swCacheService', SwCacheService)
  .service('tablesService', TablesService)
  .service('highChartsService', HighChartsService)

  // locale service
  .service('diaryLocaleService', LocaleService)

  // filters (aka html pipe transforms)
  .filter('localizeDate', localizeDateFilter)
  .filter('localizeCurrency', localizeCurrencyFilter)
  .filter('bookingsTypeFilter', BookingsTypeFilter)
  .filter('paymentTypeLabelFilter', PaymentTypeLabelFilter)
  .filter('alphaSortFilter', AlphaSortFilter)
  .filter('capitalizeFilter', CapitalizeFilter)
  .filter('idsRemoveFilter', IdsRemoveFilter)
  .filter('numberSuffixFilter', NumberSuffixFilter)
  .filter('splitCamelCaseFilter', SplitCamelCaseFilter)
  .filter('tablesListFilter', TablesListFilter)
  .filter('tagListFilter', TagListFilter)
  .filter('weekOrderFilter', WeekOrderFilter)
  .filter('trusted', ['$sce', ($sce: any) => {
    return (url: string) => $sce.trustAsHtml(url);
  }])

  .constant('appValues', {VERSION: appValues.VERSION, VERSION_SHORT: appValues.VERSION_SHORT})

  // actions
  .service('EditBookingActions', EditBookingActions)
  .service('ToastActions', ToastActions)

  .run(initServices)
  .run(stateConfig)
  .run(initOAuth2)
  .run(tracking)
  .run(cacheRegister)
  .run(checkAppVersionAgainstCache);

/**
 * Constants are defined here for AngularJS, but if you're using TypeScript you should import them, rather than using
 * AngularJS dependency injection.
 */
legacyConstantMap.forEach(({name, value}) => {
  diaryModule.constant(name, value);
});

/**
 * Defines routes needed for Hot Module Replacement to work. Using array of configs doesn't work, urls need to be string literals for WebPack to pick them up
 * and they seem to have to be in the same file as where they get imported
 */

if (module.hot) {
  module.hot.accept('app/bookings/new/newBooking.controller', () => {
    diaryModule.controller('NewBooking', require('app/bookings/new/newBooking.controller').default);
  });
  module.hot.accept('app/bookings/edit/editBooking.controller', () => {
    diaryModule.controller('EditBooking', require('app/bookings/edit/editBooking.controller').default);
  });
  module.hot.accept('app/bookings/bookingsController/bookings.controller', () => {
    diaryModule.controller('BookingsCtrl', require('app/bookings/bookingsController/bookings.controller').default);
  });
}
